export default "__VITE_ASSET__BGzEGazX__"